"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const NavHeader_1 = require("@/common/components/NavHeader");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
function default_1({ children, noStickyOnPC, }) {
    (0, NavHeader_1.hideNavHeaderOnMobile)();
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    return ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ container: true, sx: {
            position: noStickyOnPC && !maxWidth768 ? 'relative' : 'sticky',
            top: noStickyOnPC || maxWidth768 ? 0 : '50px',
            justifyContent: 'center',
            alignItems: 'center',
            flexShrink: 0,
            height: '50px',
            borderLeft: '1px solid #f8f8f8',
            borderRight: '1px solid #f8f8f8',
            backgroundColor: 'white',
            fontSize: '15px',
            '> .MuiIconButton-root:first-of-type': {
                position: 'absolute',
                left: '12px',
            },
            zIndex: 3,
        }, css: true }, { children: children })));
}
exports.default = default_1;
